import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getappMappList, deleappMapp } from "@/api/dataAll/appCorrlist";
import addApp from "./components/addAppmainapp";
export default {
  name: "appCorrtoAdvID",
  components: {
    addApp: addApp
  },
  data: function data() {
    return {
      tableTitle: [],
      obj: {},
      objs: {},
      gameId: "",
      value1: "",
      value2: [],
      total: 0,
      pagrSize: 10,
      addWayConfig: false,
      showing: false,
      tableData: [],
      searchData: {
        page: 1
      }
    };
  },
  created: function created() {
    this.searchClick();
  },
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      getappMappList().then(function (res) {
        _this.tableData = res.data || [];

        _this.tableData.forEach(function (v, index) {
          _this.timestampToTime(v.timestamp);
        });
      });
    },
    // 转换日期
    timestampToTime: function timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000

      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() + ' '; // var h = date.getHours() + ':';
      // var m = date.getMinutes() + ':';
      // var s = date.getSeconds();

      return Y + M + D;
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    changeObj: function changeObj(val) {
      this.obj = val;
    },
    handleSource: function handleSource(item, num) {
      var _this2 = this;

      this.obj = item;
      this.addWayConfig = true;
      this.$nextTick(function () {
        _this2.showing = true;

        _this2.$refs.addWayConfig.init(item, num);
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.searchClick();
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleappMapp({
                  id: id
                }).then(function (res) {
                  _this3.searchClick();
                });

                _this3.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};